export const DevicesConfigData = {
    "maxLineLimit": 25001,
    "maxFileSize": 10,
    "headerMismatchErrorMsg": "Specified headers dont match",
    "maxRowsErrorMsg": "Max number of rows allowed is ",
    "existingRecordsModifyError": "existingRecordsModifyError",
    "deviceNameUpdateError": "deviceNameUpdateError",
    "matchFileType": true,
    "checkDataType": false,
    "matchHeader": true,
    "rowMisMatchError": "Error on row",
    "knownObj": [
        {
            "headerName": "ModelNumber",
            "headerType": "string",
            "maxLength": 32
        },
        {
            "headerName": "SerialNumber",
            "headerType": "string",
            "maxLength": 32
        },
        {
            "headerName": "DeviceFriendlyName",
            "headerType": "string",
            "maxLength": 32
        },
        {
            "headerName": "SiteName",
            "headerType": "string",
            "maxLength": 32
        }
    ]
}

export const ScanenrConfigData = {
    "maxLineLimit": 25001,
    "maxFileSize": 10,
    "headerMismatchErrorMsg": "Specified headers dont match",
    "maxRowsErrorMsg": "Max number of rows allowed is ",
    "existingRecordsModifyError": "existingRecordsModifyError",
    "deviceNameUpdateError": "deviceNameUpdateError",
    "matchFileType": true,
    "checkDataType": false,
    "matchHeader": true,
    "rowMisMatchError": "Error on row",
    "knownObj": [
        {
            "headerName": "ModelNumber",
            "headerType": "string",
            "maxLength": 32
        },
        {
            "headerName": "SerialNumber",
            "headerType": "string",
            "maxLength": 32
        }
    ]
}
